(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ask-question-form"] && !Shopify.designMode) return;
  try {
    const initializeRichTextFields = (root = document) => {
    root.querySelectorAll('[data-rich-text-field]').forEach((field) => {
      if (field.dataset.richTextInitialized === 'true') {
        return;
      }

      const editor = field.querySelector('[data-rich-text-editor]');
      const valueField = field.querySelector('[data-rich-text-value]');
      const toolbar = field.querySelector('.rich-text-toolbar');
      const form = field.closest('form');

      if (!editor || !valueField || !toolbar || !form) {
        return;
      }

      field.dataset.richTextInitialized = 'true';

      const syncValue = () => {
        valueField.value = editor.innerHTML.trim();
        editor.removeAttribute('aria-invalid');
      };

      editor.addEventListener('input', syncValue);
      editor.addEventListener('blur', syncValue);

      editor.addEventListener('paste', (event) => {
        event.preventDefault();

        const text = event.clipboardData.getData('text/plain');

        document.execCommand('insertText', false, text);
        syncValue();
      });

      toolbar.addEventListener('mousedown', (event) => {
        const button = event.target.closest('button[data-command]');

        if (!button) {
          return;
        }

        event.preventDefault();

        editor.focus();

        document.execCommand(
          button.dataset.command,
          false
        );

        syncValue();
      });

      form.addEventListener('submit', (event) => {
        const messageText = editor.textContent.trim();

        if (!messageText) {
          event.preventDefault();

          editor.setAttribute('aria-invalid', 'true');
          editor.focus();

          return;
        }

        syncValue();
      });
    });
  };

  initializeRichTextFields();

  document.addEventListener('shopify:section:load', (event) => {
    initializeRichTextFields(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
